/**
 * WelcomeDialog - First-time user welcome or welcome back with tutorial offer.
 * Shown on first login or after extended inactivity to introduce/reintroduce the app.
 */

import React from 'react';
import './WelcomeDialog.css';

function WelcomeDialog({ onSkip, onStartTutorial, isWelcomeBack = false }) {
  return (
    <div className="welcome-dialog-overlay">
      <div className="welcome-dialog">
        <div className="welcome-dialog-logo">
          <img
            src="/images/btm_lantern.png"
            alt="Brings to Mind"
            className="welcome-logo"
          />
        </div>

        <h2 className="welcome-title">
          {isWelcomeBack ? 'Welcome Back to Brings to Mind' : 'Welcome to Brings to Mind'}
        </h2>

        <p className="welcome-message">
          {isWelcomeBack
            ? "It's great to see you again! Ready to continue capturing your memories, stories, and reflections?"
            : 'This is a place to capture and share your memories, stories, and reflections.'}
        </p>

        <p className="welcome-tutorial-offer">
          {isWelcomeBack
            ? 'Would you like a refresher tutorial on how to record a video?'
            : 'Would you like a quick tutorial to learn how to record your first video?'}
        </p>

        <div className="welcome-actions">
          <button
            className="welcome-btn welcome-btn-skip"
            onClick={onSkip}
            type="button"
          >
            {isWelcomeBack ? "No Thanks" : "Skip"}
          </button>
          <button
            className="welcome-btn welcome-btn-tutorial"
            onClick={onStartTutorial}
            type="button"
          >
            {isWelcomeBack ? 'Show Me' : 'Take the Tutorial'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeDialog;
